import { rgba, linearGradient, lighten } from 'polished';
import { css } from 'styled-components';

export const colors = {
    body: '#EFEFEF',
    primaryGradien: linearGradient({
        colorStops: ['#EFA057 0%', '#8948F1 100%'],
        toDirection: '180deg',
        fallback: '#8948F1',
    }),

    lightPrimaryGradien: linearGradient({
        colorStops: [`${lighten(0.3, '#EFA057')} 0%`, `${lighten(0.3, '#8948F1')} 100%`],
        toDirection: '180deg',
        fallback: '#8948F1',
    }),

    primary1: '#8948F1',
    primary2: '#EFA057',
    text: '#725A7A',
    label1: '#6A6A6A',
    label2: '#BCB8B5',

    stroke: rgba('#AC92A2', 0.3),
    
    bgDepth1: '#F5F4F4',
    bgButtonPressed: '#E0E0E0',
    bgDisabled: '#E3E3E3',

    statusGreat: '#9EEAB3',
    statusWarn: '#F8D98A',
    statusDanger: '#F38888',
};

export const neumorphism = {
    convex: css`
        box-shadow: -2px -2px 6px rgba(255, 255, 255, 0.88), 
            2px 2px 6px rgba(26, 0, 30, 0.12);
    `,
    concave: css`
        box-shadow: inset -2px -2px 4px rgba(255, 255, 255, 0.8), 
            inset 2px 2px 4px rgba(0, 0, 0, 0.16);
    `,
    buttonConcave: css`
        box-shadow: inset -2px -2px 4px rgba(255, 255, 255, 0.8), 
            inset 2px 2px 4px rgba(0, 0, 0, 0.16);
    `,
    listItemShadow: css`
        box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.08);
    `
};